import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { createSmsServiceProvider, deleteSmsServiceProvider, getSmsServiceProviders, updateSmsServiceProvider } from 'data/server_apis/thirdParty';

const smsServiceProviderAdapter = createEntityAdapter({
    selectId: (smsProvider) => smsProvider.id,
  });
  
  export const getSmsServiceProvidersThunk = createAsyncThunk(
    "SmsServiceProviders/get",
    async (_, { rejectWithValue }) => {
      try {
        return (await getSmsServiceProviders()).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const createSmsServiceProviderThunk = createAsyncThunk(
    "SmsServiceProviders/create",
    async (data, { rejectWithValue }) => {
      try {
        return (await createSmsServiceProvider(data)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const updateSmsServiceProviderThunk = createAsyncThunk(
    "SmsServiceProvider/update",
    async ({ id, data }, { rejectWithValue }) => {
      try {
        return (await updateSmsServiceProvider(id, data)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const deleteSmsServiceProviderThunk = createAsyncThunk(
    "SmsServiceProvider/delete",
    async (id, { rejectWithValue }) => {
      try {
        return (await deleteSmsServiceProvider(id)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  

  const smsServiceProvidersSlice = createSlice({
    name: "smsServiceProvider",
    initialState: smsServiceProviderAdapter.getInitialState({
      status: {},
    }),
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getSmsServiceProvidersThunk.pending, (state, action) => {
          state.status = { loading: "get" };
        })
        .addCase(getSmsServiceProvidersThunk.rejected, (state, action) => {
          state.status = { error: "get", errorMessage: action.payload?.message };
        })
        .addCase(getSmsServiceProvidersThunk.fulfilled, (state, action) => {
          state.status = { success: "get" };
          smsServiceProviderAdapter.setAll(state, action.payload);
        });
  
      builder
        .addCase(createSmsServiceProviderThunk.pending, (state, action) => {
          state.status = { loading: "create" };
        })
        .addCase(createSmsServiceProviderThunk.rejected, (state, action) => {
          state.status = {
            error: "create",
            errorMessage: action.payload?.message,
          };
        })
        .addCase(createSmsServiceProviderThunk.fulfilled, (state, action) => {
          state.status = { success: "create" };
          smsServiceProviderAdapter.addOne(state, action.payload);
        });
  
      builder
        .addCase(updateSmsServiceProviderThunk.pending, (state, action) => {
          state.status = { loading: "update", id: action.meta.arg.id };
        })
        .addCase(updateSmsServiceProviderThunk.rejected, (state, action) => {
          state.status = {
            error: "update",
            errorMessage: action.payload?.message,
            id: action.meta.arg.id,
          };
        })
        .addCase(updateSmsServiceProviderThunk.fulfilled, (state, action) => {
          state.status = { success: "update" };
          smsServiceProviderAdapter.updateOne(state, {
            id: action.meta.arg.id,
            changes: action.payload,
          });
        });
  
      builder
        .addCase(deleteSmsServiceProviderThunk.pending, (state, action) => {
          state.status = { loading: "delete", id: action.meta.arg };
        })
        .addCase(deleteSmsServiceProviderThunk.rejected, (state, action) => {
          state.status = {
            id: action.meta.arg,
            error: "delete",
            errorMessage: action.payload?.message,
          };
        })
        .addCase(deleteSmsServiceProviderThunk.fulfilled, (state, action) => {
          state.status = { success: "delete", id: action.meta.arg};
          smsServiceProviderAdapter.removeOne(state, action.meta.arg);
        });
    },
  });
  export const smsServiceProviderSelector = smsServiceProviderAdapter.getSelectors(
    (state) => state.smsProvider
  );

export const {} = smsServiceProvidersSlice.actions

export default smsServiceProvidersSlice.reducer